import React from 'react'
import { bool, func, string } from 'prop-types'
import styled, { css } from 'styled-components'

export default function Input({
	className,
	placeholder,
	value,
	onChange,
	name,
	isTextarea,
}) {
	return (
		<Block className={className}>
			{isTextarea ? (
				<StyledTextarea
					placeholder={placeholder}
					value={value}
					onChange={onChange}
					name={name}
				/>
			) : (
				<StyledInput
					placeholder={placeholder}
					value={value}
					onChange={onChange}
					name={name}
				/>
			)}
		</Block>
	)
}

Input.propTypes = {
	name: string,
	placeholder: string,
	className: string,
	value: string,
	onChange: func,
	isTextarea: bool,
}

Input.defaultProps = {
	name: '',
	placeholder: '',
	className: '',
	value: '',
	onChange: () => undefined,
	isTextarea: false,
}

const Block = styled.div`
	width: 100%;
	background-color: ${({ theme }) => theme.colors.gray[50]};
	border-radius: 16px;
	height: 56px;
`

export const commonInputStyle = css`
	width: 100%;
	height: 100%;
	background-color: inherit;
	border: none;
	outline: none;
	border-radius: 16px;
	font-size: 16px;
	line-height: 20px;
	font-weight: 500;
	padding: 18px 16px;

	::placeholder {
		color: ${({ theme }) => theme.colors.gray[400]};
	}
	:focus {
		::placeholder {
			color: transparent;
		}
	}
`

const StyledInput = styled.input`
	${commonInputStyle};
`

const StyledTextarea = styled.textarea`
	${commonInputStyle}
	resize: none;
`
